/* Reveliane – controles dos cards do drawer: mudam a quantidade TOTAL da variante via /cart/update.js
   (bundle 1+1: passo 2; avulso: passo 1; lixeira: data-rv-set = total que deve sobrar) e re-renderizam o drawer e a
   bolha do carrinho com as sections do Dawn. */
(function () {
  'use strict';
  if (window.RevelianeCart) return;
  var ocupado = false;
  function rota(p) { return (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + p; }
  function atualiza(card, unidades) {
    if (ocupado) return;
    ocupado = true;
    var drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.add('rv-cart--loading');
    /* a Shopify divide a unidade gratis do BXGY em outra linha: zera as outras linhas da variante e poe o total na paga */
    var updates = {};
    var chaves = (card.getAttribute('data-keys') || '').split(',').filter(Boolean);
    var paga = card.getAttribute('data-paid') || chaves[0];
    chaves.forEach(function (k) { updates[k] = 0; });
    updates[paga] = Math.max(0, unidades);
    fetch(rota('cart/update.js'), {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates, sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (!res.sections) return;
        var inner = document.querySelector('cart-drawer .drawer__inner');
        if (inner) {
          var html = new DOMParser().parseFromString(res.sections['cart-drawer'], 'text/html');
          var novo = html.querySelector('.drawer__inner');
          if (novo) inner.innerHTML = novo.innerHTML;
          var vazio = res.item_count === 0;
          if (drawer) drawer.classList.toggle('is-empty', vazio);
          var items = document.querySelector('cart-drawer-items');
          if (items) items.classList.toggle('is-empty', vazio);
        }
        var bolha = document.getElementById('cart-icon-bubble');
        if (bolha && res.sections['cart-icon-bubble']) {
          var h2 = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html');
          var n2 = h2.querySelector('.shopify-section');
          if (n2) bolha.innerHTML = n2.innerHTML;
        }
        document.dispatchEvent(new CustomEvent('cart:update', { detail: res }));
      })
      .catch(function () { window.location.href = rota('cart'); })
      .finally(function () { ocupado = false; if (drawer) drawer.classList.remove('rv-cart--loading'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rv-step], [data-rv-set]');
    if (!btn) return;
    var card = btn.closest('[data-rv-card]');
    if (!card) return;
    e.preventDefault();
    var total = parseInt(card.getAttribute('data-units'), 10) || 0;
    if (btn.hasAttribute('data-rv-step')) atualiza(card, total + parseInt(btn.getAttribute('data-rv-step'), 10));
    else atualiza(card, parseInt(btn.getAttribute('data-rv-set'), 10) || 0);
  });
  window.RevelianeCart = { atualiza: atualiza };
})();
